<template>
  <div class="add-listing-page container1400">
    <v-container>
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <div class="text-h5 mb-5">{{ $t("Addvideotour") }}</div>
      <div class="elevation-1 pa-5 white">
        <v-row>
          <v-col cols="12" lg="6">
            <v-dialog
              v-model="dialog1"
              scrollable
              max-width="600px"
              width="100%"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  color="light-blue"
                  class="mr-2"
                  dark
                  x-large
                  v-bind="attrs"
                  v-on="on"
                  >{{ $t("string610") }}</v-btn
                >
              </template>
              <v-card>
                <v-form ref="form1" v-model="valid1" lazy-validation>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-btn color="red" icon @click="dialog1 = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input
                          prepend-icon="mdi-video"
                          type="file"
                          v-model="file"
                          show-size
                          v-bind:label="$t('ClickHereSelectVideo')"
                          @change="uploadVideo"
                          accept="video/mp4"
                          outlined
                          persistent-hint
                          v-bind:hint="$t('UploadVideoHind')"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" lg="6">
            <v-dialog
              v-model="dialog2"
              scrollable
              max-width="600px"
              width="100%"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  color="light-blue"
                  class="mr-2"
                  dark
                  x-large
                  v-bind="attrs"
                  v-on="on"
                  >{{ $t("string5") }}</v-btn
                >
              </template>
              <v-card>
                <v-form ref="form2" v-model="valid2" lazy-validation>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-btn color="red" icon @click="dialog2 = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          hide-details="auto"
                          type="text"
                          v-model="video_url"
                          v-bind:label="$t('Pastevideourlfromyoutube')"
                          outlined
                          :rules="reqRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn
                          dark
                          x-large
                          min-width="150"
                          color="light-blue"
                          @click="saveUrl"
                        >
                          <span class="mr-2">{{ $t("Add") }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="(item, i) in videos" :key="i" cols="2">
            <div class="text-right pb-4">
              <v-btn icon color="red" @click="removeVideo(item)">
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </div>
            <v-img
              :src="$store.state.videoUrl + 'thumbnail/' + item.thumbnail"
              aspect-ratio="1.7"
              width="100%"
              height="auto"
              class="grey lighten-2"
            ></v-img>
          </v-col>
          <v-col v-for="item in yVideos" :key="item" cols="2">
            <div class="text-right pb-4">
              <v-btn icon color="red" @click="removeUrl(item)">
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </div>
            <youtube
              :video-id="getVideoId(item)"
              player-width="100%"
              player-height="150px"
            ></youtube>
          </v-col>
        </v-row>
      </div>
      <div class="text-right pt-5 pb-5">
        <v-btn color="light-blue" class="mr-2" rounded dark @click="skipStep">
          <span class="mr-2">{{ $t("Continue") }}</span>
          <v-icon size="small">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </v-container>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </div>
</template>

<script>
// @ is an alias to /src
import ListingService from "@/services/ListingService";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import swal from "sweetalert";

export default {
  name: "AddVideos",
  props: ["data"],
  components: { WaitDialogComponent },
  data() {
    return {
      waitDialog: false,
      valid1: null,
      valid2: null,
      videos: [],
      yVideos: [],
      file: null,
      video_url: "",
      dialog1: false,
      dialog2: false,
      error: null,
      reqRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
          return pattern.test(value) || this.$t("string720");
        }
      ]
    };
  },
  methods: {
    skipStep() {
      this.$router.push({
        name: "EditAvailabilityComponent",
        params: { id: this.data.property_id }
      });
    },
    getVideoId(val) {
      return this.$youtube.getIdFromURL(val.toString());
    },
    async saveUrl() {
      await this.$refs.form2.validate();
      if (this.valid2) {
        this.waitDialog = true;
        await ListingService.addYoutubeUrl({
          property_id: this.data.property_id,
          video_url: this.video_url
        })
          .then(result => {
            setTimeout(
              () => (
                (this.waitDialog = false),
                (this.video_url = ""),
                (this.dialog2 = false),
                this.$refs.form2.reset(),
                (this.yVideos = result.data)
              ),
              500
            );
          })
          .catch(err => {
            this.error = err.response.data.errors;
            this.dialog2 = false;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    removeUrl(data) {
      swal({
        text: this.$t("string691"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.waitDialog = true;
          ListingService.removeYoutubeUrl({
            item: data,
            property_id: this.data.property_id
          })
            .then(result => {
              setTimeout(
                () => ((this.waitDialog = false), (this.yVideos = result.data)),
                500
              );
            })
            .catch(err => {
              this.error = err.response.data.errors;
              setTimeout(() => (this.waitDialog = false), 500);
            });
        }
      });
    },
    async uploadVideo() {
      if (this.file) {
        if (this.file.size / 1024 / 1024 > 50) {
          return (this.error = [
            { msg: "File too large.Maximum File Limit is 50 MB" }
          ]);
        }
        this.waitDialog = true;
        let formData = new FormData();
        formData.append("property_id", this.data.property_id);
        formData.append("file", this.file);
        await ListingService.uploadVideo(formData)
          .then(result => {
            this.file = null;
            this.$refs.form1.reset();
            this.dialog1 = false;
            setTimeout(
              () => ((this.waitDialog = false), (this.videos = result.data)),
              2000
            );
          })
          .catch(err => {
            this.error = err.response.data.error;
            this.file = null;
            this.dialog1 = false;
            this.$refs.form1.reset();
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    removeVideo(data) {
      swal({
        text: this.$t("string691"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.waitDialog = true;
          ListingService.videoDelete({
            id: data._id,
            property_id: this.data.property_id
          })
            .then(result => {
              this.dialog1 = false;
              setTimeout(
                () => ((this.waitDialog = false), (this.videos = result.data)),
                2000
              );
            })
            .catch(err => {
              this.error = err.response.data.errors;
              this.dialog1 = false;
              setTimeout(() => (this.waitDialog = false), 500);
            });
        }
      });
    }
  }
};
</script>

<style></style>
